import React from "react";
import DataTable from "../reusable/DataTable";
import { AccessControl } from "@careinfo/permission-required";
import TableActionButton from "../reusable/TableActionButton";
import SwitchButton from "../reusable/SwitchButton";
import NACell from "../reusable/DataTable/NACell";
import APIS from "../../constant/Endpoint";
import { useNavigate } from "react-router-dom";
import usePermission from "../../customHooks/usePermission";
const ShipviaList = ({ handleIsActive }) => {
  // const { handleIsActive } = props;
  const navigate = useNavigate();
  const canUpdateSetting = usePermission({
    allowedPermissions: ["can_update_setting"],
  });
  const handleRowClick = (row: any) => {
    if (canUpdateSetting.isAllowed=== false) return;
    navigate(`edit/${row?.original?.id}`);
  };
  const defaultColumns: any = [
    {
      header: "Name",
      accessorKey: "name",
      cell: NACell,
    },
    {
      header: "Track Url",
      accessorKey: "track_url",
      cell: NACell,
    },
    {
      header: "Default",
      accessorKey: "is_default",
      cell: ({ row, getValue }) => (
        <div onClick={(e) => e.stopPropagation()}>
          <AccessControl
            children={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={false}
                onChange={handleIsActive}
              />
            }
            allowedPermissions={["can_update_setting"]}
            renderNoAccess={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={true}
                onChange={handleIsActive}
              />
            }
          />
        </div>
      ),
    },
  ];
  return (
    <DataTable
      url={APIS.SHIP_VIA}
      queryKey={"ship-via"}
      columns={defaultColumns}
      addNewPagePath={"create"}
      tableName={"ship-via"}
      onRowClick={handleRowClick}
    />
  );
};

export default ShipviaList;
